import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearArtistData, getArtists } from '../../../store/artist/actions';
import { readableCityName } from '../../../common/commonFunction';

const useArtist = (router) => {
    const dispatch = useDispatch();

    const { artists, totalArtist } = useSelector((state) => ({
        artists: state.artist.artists,
        totalArtist: state.artist.totalArtist,
    }));

    let filterData = {
        start: 0,
        limit: 12,
        search: '',
        sort_by: '',
        sort_order: 'desc',
    };

    const getListData = useCallback(
        (start, loadMoreData) => {
            filterData.start = start || 0;
            dispatch(getArtists(filterData, router.navigate));
        },
        [dispatch, router.navigate],
    );

    useEffect(() => {
        getListData('', false);
    }, []);

    const loadMore = () => {
        const start = filterData.start + filterData.limit;
        filterData.start = start;
        getListData(start, true);
    };

    return {
        artists,
        totalArtist,
        loadMore,
    };
};

export default useArtist;
